import React, { Fragment } from 'react';
import { CommentsSectionLoader } from '@confluence-classic/confluence-utils/entry-points/CommentsSectionLoader.ts';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider/index.js';

import { Box } from '@atlaskit/primitives/compiled';

import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { usePageContentId } from '@confluence/page-context';
import { SpaceOverviewSwitcherLoader } from '@confluence/space-overview/entry-points/SpaceOverview.ts';
import { EmbeddedViewPageLoader } from '@confluence/embedded-confluence/entry-points/EmbeddedViewPage.ts';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';
import { LazyDwellTime } from '../lazyComponents.js';
import { CommentContextWrapper } from '../commentContextWrapper.tsx';

// Currently SSR renders SpaceOverviewLoader directly
// TODO: We should render everything on the server side to unify the route files

type EmbeddedSpaceOverviewProps = {
	spaceKey: string;
	contentId: string;
};

const EmbeddedSpaceOverview = ({ spaceKey, contentId }: EmbeddedSpaceOverviewProps) => {
	return (
		<Box padding="space.200">
			<EmbeddedViewPageLoader
				contentId={contentId}
				spaceKey={spaceKey}
				classicComments={CommentsSectionLoader}
				ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
				showHeaderButtons={false}
			/>
		</Box>
	);
};

type SpaceOverviewProps = {
	spaceKey: string;
};

const SpaceOverview = ({ spaceKey }: SpaceOverviewProps) => {
	return <SpaceOverviewSwitcherLoader spaceKey={spaceKey} />;
};

type SpaceOverviewRouteComponentProps = {
	spaceKey: string;
};

export const SpaceOverviewRouteComponent = ({ spaceKey }: SpaceOverviewRouteComponentProps) => {
	const [contextContentId] = usePageContentId();
	const contentId: string = contextContentId ?? '';
	const component = isEmbeddedConfluence_DO_NOT_USE() ? (
		<EmbeddedSpaceOverview contentId={contentId} spaceKey={spaceKey} />
	) : (
		<SpaceOverview spaceKey={spaceKey} />
	);

	return (
		<Fragment>
			<ContentExtensionsProvider>
				<CommentContextWrapper>{component}</CommentContextWrapper>
			</ContentExtensionsProvider>
			<LazyDwellTime />
		</Fragment>
	);
};
export default SpaceOverviewRouteComponent;
